import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("voltaic_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);
  const [assistantOpen, setAssistantOpen] = useState(false);
  const [exitOfferOpen, setExitOfferOpen] = useState(false);
  const [promo, setPromo] = useState(null); // {code, percent, kind}
  const [paymentsMode, setPaymentsMode] = useState("test");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`)
      .then((r) => r.json())
      .then((d) => d.payments_mode && setPaymentsMode(d.payments_mode))
      .catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("voltaic_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) =>
          i.product_id === product.id
            ? { ...i, quantity: Math.min(i.quantity + qty, product.stock || 99) }
            : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: product.image,
          stock: product.stock,
          quantity: qty,
        },
      ];
    });
  };

  const updateQty = (id, qty) => {
    if (qty <= 0) return setItems((prev) => prev.filter((i) => i.product_id !== id));
    setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: qty } : i)));
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => {
    setItems([]);
    setPromo(null);
  };

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  const shipping = subtotal === 0 || subtotal >= 999 ? 0 : 29;
  const discount = promo ? Math.round(subtotal * promo.percent) / 100 : 0;
  const total = Math.max(0, subtotal - discount + shipping);

  return (
    <CartContext.Provider
      value={{
        items, isOpen, setIsOpen, assistantOpen, setAssistantOpen,
        exitOfferOpen, setExitOfferOpen,
        addItem, updateQty, removeItem, clear,
        subtotal, count, shipping, discount, total, promo, setPromo, paymentsMode,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
